export const tenantQueryKeys = {
  all: ['tenant'] as const,
  profile: () => [...tenantQueryKeys.all, 'profile'] as const,
  costSettings: () => [...tenantQueryKeys.all, 'costSettings'] as const,
  users: () => [...tenantQueryKeys.all, 'users'] as const,
  user: (userId: string) => [...tenantQueryKeys.all, 'user', userId] as const,
  userRoles: (userId: string) =>
    [...tenantQueryKeys.all, 'userRoles', userId] as const,
  labels: () => [...tenantQueryKeys.all, 'labels'] as const,
  label: (labelId: string) =>
    [...tenantQueryKeys.all, 'label', labelId] as const,
  labelUsers: (labelId: string) =>
    [...tenantQueryKeys.all, 'labelUsers', labelId] as const,
  userLabels: (userId: string) =>
    [...tenantQueryKeys.all, 'userLabels', userId] as const,
  groups: () => [...tenantQueryKeys.all, 'groups'] as const,
  group: (groupId: string) =>
    [...tenantQueryKeys.all, 'group', groupId] as const,
  groupMembers: (groupId: string) =>
    [...tenantQueryKeys.all, 'groupMembers', groupId] as const,
  userGroups: (userId: string) =>
    [...tenantQueryKeys.all, 'userGroups', userId] as const,
};
